import React, { useEffect, useRef } from "react";
import cx from "classnames";
import TinyMCE from "react-tinymce";

import styles from "./richText.module.scss";
import contentStyle from "./richTextEditorContent.scss";

interface RichTextEditorProps {
  className?: string;
  content: any;
  inline?: boolean;
  toolbar?: string;
  placeholder?: string;
  bodyColor?: string;
  height?: number;
  fonts?: any;
  // eslint-disable-next-line no-unused-vars
  onChange: (content: string) => void;
  fontSizeFormats?: string;
  plugins?: string;
  customFontStyle?: string;
}

const RichTextEditor:React.FC<RichTextEditorProps> = ({className, content, inline, toolbar, placeholder, bodyColor = "#000", onChange, height = 160, fonts, fontSizeFormats, plugins, customFontStyle}) => {
  const toolbarValue = toolbar || "undo redo | bold italic | alignleft aligncenter alignright | link";
  const pluginValues = plugins || "code, noneditable, link, paste, autolink";
  const richEditor=useRef<any>(null);

  useEffect(() => {
    if (richEditor.current && richEditor.current.setContent) {
      richEditor.current.setContent(content);
    }
  }, [content]);

  const handleEditorSetup = (editor: any) => {
    editor.on("PostRender", () => {
      richEditor.current = editor;
      richEditor.current.setContent(content);
      setTimeout(() => {
        richEditor.current = editor;
      }, 1000);
    });
  };

  return (
    <TinyMCE
      className={cx(styles.richTextEditor, className)}
      content={content}
      ref = {richEditor}
      config={{
        branding: false,
        statusbar: false,
        contextmenu: false,
        inline: inline,
        theme: "silver",
        plugins: pluginValues,
        menubar: false,
        toolbar1: toolbarValue,
        resize: false,
        height: height,
        paste_retain_style_properties: "color font-size",
        fontsize_formats: fontSizeFormats,
        font_formats:fonts,
        content_css: [
          contentStyle, customFontStyle,
          // need to change this to the actual font family in use.
          "https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
        ],
        content_style: `
          body.mce-content-body { color: ${bodyColor}; }
          .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before { color: ${bodyColor}; }
        `,
        default_link_target: "_blank",
        browser_spellcheck: true,
        convert_urls: false,
        relative_urls: false,
        remove_script_host: false,
        placeholder: placeholder,
        setup: (editor) => {
             // having timeout to set the instance after the render of tinymce
            handleEditorSetup(editor);
        },
      }}
      onChange={onChange}
    />
  );
}

export default RichTextEditor;
